module.exports = __webpack_public_path__ + "img/contact_5.36281b0d.png";